import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from '@mui/material/FormControl';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import WeekPicker from "../../TimesheetItems/WeekPicker";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import MUIDataTable from 'mui-datatables';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions,muiLoaderOptionsWithoutLoading} from '../../utils';
import { Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import EditSummaryDialog from "../../AdminItems/EditDialogue/EditSummary";
import Tooltip from '@mui/material/Tooltip';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowY: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },
    scrollContainer: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

}));

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 130,
            borderBottom: '1px solid #e0e0e0',
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            position: 'sticky',
            top: 56, // match toolbar height
            backgroundColor: '#fff',
            zIndex: 120,
          },
        },
      },
    },
  });


export default function ReportTimeEntry({ start, end, poid = 0 }) {
	const [refresh, setRefresh] = React.useState(false);
	const [open, setOpen] = React.useState(false);
	const [StartDate, setStartDate] = React.useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'));
	const [EndDate, setEndDate] = React.useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'));
	const [dataSet, setDataSet] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [permission, permissionSet] = React.useState([]);
    const [taskVariable, setTaskVariable] = React.useState([]);
    const [customColumns, setCustomColumns] = React.useState([]);
    const [expand, setExpand] = React.useState("");
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(true);
    const [addCols, setAddCols] = React.useState(true);
    const [overTime, setOverTime] = React.useState([]);
    const [fullScreen, setFullScreen] = React.useState(false);
	var dataset = [];
	let overtime = [];


    const classes = pageStyles();

    const initialValues = {
        POID: ''
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
            
    });

    React.useEffect(() => {
    	checkAuthentication();
        if (refresh) {
              if (start) setStartDate(start);
       		  if (end) setEndDate(end);
            
            fetch(`/api/User/Permission`)
                .then(res => res.json())
                .then(json => permissionSet(json))

            fetch(`/api/taskVariable/dropdown`)
                .then(res => res.json())
                .then(json => {
					setTaskVariable(json);
				})
            setRefresh(false);
        }
        if (dataSet.length && addCols) {
            addColumn(taskVariable)
        }
    }, [refresh]);
    
	const convertDates = (json) => {
		json.forEach(eachObj => {
			if (eachObj.Rate) {
				const byteArray = new Uint8Array(eachObj.Rate.data);
				const textDecoder = new TextDecoder();
				const res = textDecoder.decode(byteArray);
				const r = parseFloat(res).toFixed(2);
				eachObj.Rate = r;
			}
		});
		if (json.length===0){
			setAlertText("No Time Entries available for the time selected");
			setAlert(true);
		}
		setDataSet(json);
		dataset = JSON.parse(JSON.stringify(json));
		setIsLoading(false);
		return json;
	};
	
	const handleStatus = (status) => {
		if (status == 0) {
			return ("Pending");
		}
		if (status == 1) {
			return ("Approved");
		}
		if (status == -1) {
			return ("Rejected");
		}
	};
    
    /*const getDataSet = async () => {
        logger(`/api/Reports/time_entry/${moment(StartDate).format('YYYY-MM-DD')}/${moment(EndDate).format('YYYY-MM-DD')}/${poid}/0`)
        await fetch(`/api/Reports/time_entry/${moment.utc(StartDate).format('YYYY-MM-DD')}/${moment.utc(EndDate).format('YYYY-MM-DD')}/${poid}/0`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                logger('output', json)
                convertDates(json)
                setRefresh(true);
            })
    }*/
    
    const getDataSet = async () => {
		try {
			const apiUrl = `/api/Reports/time_entry/${moment.utc(StartDate).format('YYYY-MM-DD')}/${moment.utc(EndDate).format('YYYY-MM-DD')}/${poid}/0`;
			logger(apiUrl);

			const response = await fetch(apiUrl, { method: 'GET' });
			const json = await response.json();
			
			convertDates(json);
			logger('output', json);

			if (json.length > 0) {
				await GetOverTime(json[0].SOWID); // Await here is correct
			}

			//setRefresh(true);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	const GetOverTime = async (sow) => {
		try {
			const response = await fetch(`/api/SOW/OverTime/${sow}`, { method: 'GET' });
			const json = await response.json();
			setOverTime(json); // Ensure `overTime` is defined in the appropriate scope
			overtime = [...json];
		} catch (error) {
			console.error('Error fetching overtime data:', error);
		}
	};

    const handleGenerate = async () => {
		setIsLoading(true);
		setOpenLogs(true);
        await getDataSet();
        setRefresh(true);
    };

	const downloadFile = async () => {
		await getDataSet();

		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet('Sheet 1');

		if (dataset) {
			var dynamicColumns = [];
			if(expand === "detailed") {
				taskVariable.forEach((e) => {
					dynamicColumns.push(e.Name);
				});
			} else if(expand === "summary") {
				dynamicColumns.push("Task Variables");
			}

			var columnsIncludeInSheet = ["Date", "WeekOf", "Name", "Program", "Project", "Task", "Hours", "Status", "FlagType", "Position", "PO","PONumber", "RawRate"];
			var matchingColumnsFromDataset = ["DayOf", "WeekOf", "Name", "Lab_Name", "Project", "Task", "Hours", "VerifyStatus", "FlagType", "Position_FullName", "PO","PoNumber", "Rate"];
		
			columnsIncludeInSheet = columnsIncludeInSheet.concat(dynamicColumns);
			matchingColumnsFromDataset = matchingColumnsFromDataset.concat(dynamicColumns);
			
			//const headers = Object.keys(dataset[0]);
			
			//const headerRow = worksheet.addRow(headers);
			// Set up column headers with bold font
			const headerRow = worksheet.addRow(columnsIncludeInSheet);
			headerRow.eachCell((cell) => {
				cell.font = { bold: true };
			});
			worksheet.autoFilter = {
				from: 'A1',
				to: 'AD', 
			};

			dataset.forEach((item, dataIndex) => {
				const row = [];
				for (let i = 0; i < matchingColumnsFromDataset.length; i++) {
					const columnKey = matchingColumnsFromDataset[i];

					if (columnsIncludeInSheet[i] === "Date" || columnsIncludeInSheet[i] === "WeekOf") {
						item[columnKey] = moment.utc(item[columnKey]).format("MM/DD/YYYY");
					}

					if (columnsIncludeInSheet[i] === "Status") {
						const status = item[columnKey];
						item[columnKey] = handleStatus(status);
					}

					if (columnsIncludeInSheet[i] === "FlagType") {
						item[columnKey] = item.ProjectGroupName === "BCI" ? "non-Billable" : item[columnKey];
					}
					
					if (columnsIncludeInSheet[i] === "RawRate") {
						if (item.Rate && item.FlagType) {
							const r = parseFloat(item.Rate).toFixed(2);
							item[columnKey] = calculateRate(overtime, r, item.FlagType);
						}
					}

					if(columnsIncludeInSheet[i] === "POName") {
						if(item.IsBillable == 0) {
							item[columnKey] = "non-Billable"
						} else {
							if(item.PO) {
								item[columnKey] = `${item.PO}`
							}
						}
					}

					if(columnsIncludeInSheet[i] == "Task Variables") {
						let taskList = ""
						taskVariable.forEach((task) => {
							if(item[task.Name]) {
								taskList = taskList + task.Name + ": " + item[task.Name] + '\n';
							}
						});
						taskList = taskList.trim()
						item[columnKey] = taskList;
					}

					row.push(item[columnKey]);
				}

				const currRow = worksheet.addRow(row);
				currRow.eachCell((cell, colNumber) => {
					if (columnsIncludeInSheet[colNumber-1] === "Status" && (item.VerifyStatus === "Pending" || item.VerifyStatus === "Rejected")) {
						cell.font = { color: { argb: 'eb4034' } };
					}
					if ((columnsIncludeInSheet[colNumber-1] === "FlagType") && item.overTimeWarning) {
						cell.font = { color: { argb: 'eb4034' } };
					}
				});
			});

			columnsIncludeInSheet.forEach((header, index) => {
				let headerLength = header ? header.length : 0; // Handle header if undefined
				headerLength = headerLength * 1.1; // Account for larger bold letters
				var maxColumnWidth = worksheet.getColumn(index + 1).values.reduce((maxWidth, value) => {
					if (value && value.length > maxWidth) {
						return value.length;
					}
					return maxWidth;
				}, 0);
			
				if (maxColumnWidth > 40) {
					maxColumnWidth = 40;
				}
				worksheet.getColumn(index + 1).width = Math.max(headerLength, maxColumnWidth) + 2;
				//worksheet.getColumn(index + 1).width = 20;
				worksheet.getColumn(index + 1).alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
			});

			// Generate the Excel file as a Blob
			const buffer = await workbook.xlsx.writeBuffer();
			const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			const link = document.createElement('a');
			const url = URL.createObjectURL(blob);
			const currentDate = moment.utc().format("yyyy-MM-DD");
			link.href = url;
			link.download = currentDate + "_UnBilledTimeEntries.xlsx";
			link.click();
			URL.revokeObjectURL(url);
		} else {
			console.log("No data available to download.");
		}
	};
    
    const handleAlertClose = () => {
        setAlert(false);
    };

	const addColumn = (list) => {
		logger("addColumn", list);
		const editableColumns = [
			{
				name: "Actions",
				options: {
					filter: false,
					sort: false,
					empty: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						return (
							<div>
								{logger(dataSet[dataIndex])}
								{dataSet[dataIndex].WeekOf !== moment.utc(null).format("MM/DD/YYYY") ? <EditSummaryDialog key={rowIndex}
									callRefresh={callRefresh}
									handleEditCallback={handleEditCallback}
									permission={permission}
									data={{ Name: dataSet[dataIndex].Name, UserID: dataSet[dataIndex].UserID, WeekOf: dataSet[dataIndex].WeekOf }} /> : "No Time Entered"}
							</div>
						);
					}
				}
			},
			{
				name: "DayOf",
				label: "Date",
				options: {
					filter: false,
					sort: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						return (
                            moment.utc(dataSet[dataIndex].DayOf).format("MM/DD/YYYY")
                        );
                    }
                }
            },
            {
                name: "WeekOf",
                label: "WeekOf",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        return (
                            moment.utc(dataSet[dataIndex].WeekOf).format("MM/DD/YYYY")
                        );
                    }
                }
            },
            {
                name: "Name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Lab_Name",
                label: "Program",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Project",
                label: "Project",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },

			{
				name: "Task",
				label: "Task",
				options: {
					filter: true,
					sort: true,
					//    position: "sticky",
					customBodyRenderLite: (dataIndex) => {
						const task = dataSet[dataIndex].Task;
						const endDate = dataSet[dataIndex].PoAssociateEndDate;

						if(endDate){
							return (
	                        <Tooltip title={moment(endDate).isSameOrBefore(moment(new Date())) ? `L&P Expired on: ${moment(endDate).format("MM/DD/YYYY")}`: ""} placement="top-end">
								<div style={moment(endDate).isSameOrBefore(moment(new Date())) ? { color: "red" } : {}}>
									{task}
								</div>
							</Tooltip>
	                    	);
                    	} else {
							return (
	                        <Tooltip title={`There is no L&P set to Task : ${task}`} placement="top-end">
								<div style={{ color: "red" }}>
									{task}
								</div>
							</Tooltip>
	                    	);
						}
					}
				}
			},

			{
				name: "Hours",
				label: "Hours",
				options: {
					filter: false,
					sort: true,
					//    position: "sticky",
				}
			},
			{
				name: "VerifyStatus",
				label: "Status",
				options: {
					filter: false,
					sort: false,
					customBodyRenderLite: (dataIndex) => {
						const status = dataSet[dataIndex].VerifyStatus;
						let statusText = handleStatus(status);
						let style = {};
						let tooltip = "";

						if (status === 0 || status === -1) {
							// Pending
							style = { color: "red" };
							tooltip = "Not Yet Approved";
						} else if (status === 1) {
							// Approved
							style = { color: "black" };
							tooltip = "Approved";
						}

						return (
							<Tooltip title={tooltip}>
								<div style={style}>
									{ handleStatus(status)}
								</div>
							</Tooltip>
						);
					}
				}
			},
			{
				name: "FlagType",
				label: "FlagType",
				options: {
					sort: true,
					filter: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						if (dataSet[dataIndex].ProjectGroupName == "BCI") {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].FlagType) {

								return (
									<Tooltip title={dataSet[dataIndex].overTimeWarning ? "overTimeWarning" : ""}>
										<div style={dataSet[dataIndex].overTimeWarning ? { color: "red" } : {}}>

											{dataSet[dataIndex].FlagType}
										</div>
									</Tooltip>
								);
							}

						}
					}
				}
			},
			{
				name: "Position_FullName",
				label: "Position",
				options: {
					filter: false,
					sort: true,
					display: true,
					//    position: "sticky",
				}
			},

			{
				name: "PO",
				label: "POName",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`dataSet[dataIndex]`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].PO !== null)
								return (
									<>{dataSet[dataIndex].PO}</>
								);
							else
								return (
									<div>
										 <Tooltip title={`There is no L&P set to the Task`} placement="top-end" className={classes.root}>
											<ReportGmailerrorredIcon color='error' />
										</Tooltip>
										<EditSummaryDialog
											callRefresh={callRefresh}
											handleEditCallback={handleEditCallback}
											permission={permission}
											data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD') }} />
									</div>
								);
						}
					}
				}
			},
			{
				name: "PoNumber",
				label: "PONumber",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`dataSet[dataIndex]`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].PO !== null)
								return (
									<>{dataSet[dataIndex].PO} </>
								);
							else
								return (
									<div>
										 <Tooltip title={`There is no L&P set to the Task`} placement="top-end" className={classes.root}>
											<ReportGmailerrorredIcon color='error' />
										</Tooltip>
										<EditSummaryDialog
											callRefresh={callRefresh}
											handleEditCallback={handleEditCallback}
											permission={permission}
											data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD') }} />
									</div>
								);
						}
					}
				}
			},{
				name: "PoNumber",
				label: "PONumber",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`dataSet[dataIndex]`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].PO !== null)
								return (
									<>{dataSet[dataIndex].PoNumber}</>
								);
							else
								return (
									<div>
										 <Tooltip title={`There is no L&P set to the Task`} placement="top-end" className={classes.root}>
											<ReportGmailerrorredIcon color='error' />
										</Tooltip>
										<EditSummaryDialog
											callRefresh={callRefresh}
											handleEditCallback={handleEditCallback}
											permission={permission}
											data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD') }} />
									</div>
								);
						}
					}
				}
			},
			{
				name: "Rate",
				label: "RawRate",
				options: {
					sort: true,
					filter: true,
					filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "Not Set";
							}
							return val;
						}
					},
					customBodyRenderLite: (dataIndex, rowIndex) => {
						logger(`value`, dataSet[dataIndex])
						if (dataSet[dataIndex].IsBillable == 0) {
							return (
								<>-----</>
							);
						}
						else {
							if (dataSet[dataIndex].Rate) {
								return (
									<>{overTime.length ? calculateRate(overTime, dataSet[dataIndex].Rate, dataSet[dataIndex].FlagType) : dataSet[dataIndex].Rate}</>
								);
							}
							else {
								return (
									 <Tooltip title={`There is no L&P set to the Task`} placement="top-end" className={classes.root}>
											<ReportGmailerrorredIcon color='error' />
										</Tooltip>
								);
							}
						}
					}

				}
			},
		];
		if (expand==="detailed") {
			list.forEach((e) => {
				editableColumns.push({
					name: `${e.Name}`,
					label: `${e.Name}`,
					options: {
						filter: true,
						sort: true,
					}
				})
			})
		}else if(expand==="summary"){
			editableColumns.push(
				{
	            name: "TaskVariables",
	            label: "TaskVariables",
					options: {
						filter: false,
						sort: false,
	                filterOptions: {
						renderValue: val => {
							if (val === "" || val === null || val === undefined) {
								return "";
							}
							return val;
						}
					},
	                customBodyRender: (value, tableMeta, updateValue) => {
						var rowIndex = tableMeta.rowIndex;
						
						return list.map((item, idx) => {
							var columnName = item.Name;
							var data = dataSet[rowIndex];
							var value = data[columnName]?data[columnName]:'';
							return (data[columnName] &&
                                <React.Fragment key={idx}>
                                    {columnName + ': ' + value}
                                    <br />
                                </React.Fragment>
                            );
						});
	                }
	            }
	        })
		}

		setAddCols(false);
		setCustomColumns(editableColumns);
	};

	const handleClickOpen = () => {
		setRefresh(true)
		setOpen(true)
		setExpand("");
	};

	const handleStartDate = (Data) => {
		setStartDate(Data.target.value);
		logger(Data.target.value);
	}

	const handleEndDate = (Data) => {
		setEndDate(Data.target.value);
		logger(Data.target.value);
	}
	
	const handleRadioButton = (event) => {
		setExpand(event.target.value);
	}

	const handleClose = () => {
		//   setPOChoices(0);
		setOpen(false);
	};
	
	const handleMinimize = () => {
		setFullScreen(false);
	};
	
	const handleMaximize = () => {
	setFullScreen(true);
	};

	const handleOpenForLogs = () => {
		setOpenLogs(true)
	};

	const handleCloseForLogs = () => {
		setDataSet([])
		setCustomColumns([])
		setOpenLogs(false);
		setAddCols(true);
		setIsLoading(true);
		setFullScreen(false);
	};
	
	const CustomToolbarTitle = () => (
		<Typography variant="h6" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
			Report All Time Entries
		</Typography>
	);

	const callRefresh = () => {
		setRefresh(true);
	};

	const handleEditCallback = (childData) => {
		fetch("/api/Summary", {
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				"ApprovalAll": childData.approvalAll,
				"Week": childData.Week
			})
		})

		logger(childData)
		//   window.location.reload();
		setRefresh(true)
	};

	const MakeToolbar = () => {
		return (
			<>
				<Button component={Link} color="inherit" to="/Summary">Go to Summary</Button>
			</>
		);
		logger("createTB" + MakeToolbar)
	}
	const getSavedRowsPerPage = () => {
		const savedValue = localStorage.getItem('rowsPerPage');
		return savedValue ? parseInt(savedValue) : 100; // Default value
	}
	// Save to local storage
	const saveRowsPerPage = (value) => {
		localStorage.setItem('rowsPerPage', value.toString());
	}

	const initialRowsPerPage = getSavedRowsPerPage();

	var baseOptions = {
		filter: true,
		filterType: 'dropdown',
		responsive: 'standard',
		fixedHeader: true,
		fixedSelectColumn: false,
		rowsPerPage: initialRowsPerPage,
		tableBodyHeight: "auto",
        tableBodyMaxHeight: "auto",
		rowsPerPageOptions: [10, 20, 50, 100],
		customToolbar: () => <MakeToolbar />,
		textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
		},
		selectableRows: 'none',
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				logger("newColumns", newColumns);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);				
				if (expand === "summary") {
					for (let i = 0; i < dataSet.length; i++) {
						let taskVarsString = "";
						let eachRow = dataSet[i];
						logger(eachRow);
						for (let k = 0; k < taskVariable.length; k++) {
							let eachTaskVar = taskVariable[k].Name;
							for (let j in eachRow) {
								if (eachTaskVar === j && eachRow[j] !== null && eachRow[j] !== undefined && eachRow[j] !== "") {
									taskVarsString = taskVarsString + eachTaskVar + ": " + eachRow[eachTaskVar] + "\n";
								}
							}
						}
						data[i].data[data[i].data.length - 1] = taskVarsString;
					}
				}
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					logger("eachrow", eachRow)
					eachRow[8] = handleStatus(eachRow[8]);
					if(eachRow[11] !== null) {
						eachRow[11]; 
					}
					eachRow[13] = calculateRate(overTime, eachRow[13], eachRow[9]);
					eachRow[1] =  moment.utc(eachRow[1]).format("MM/DD/YYYY");
					eachRow[2] =  moment.utc(eachRow[2]).format("MM/DD/YYYY");
				}
				return customBodyForExcelReport({ data: data, headers: headers, columnIndexToRemove:0} );
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			var add_date = true;
			var columnIndexToRemove = 0;
			var numberOfColumnsToRemove = null;
			var filename = 'TimeEntry.xlsx';
			
			if (columnIndexToRemove !== null) {
				if (numberOfColumnsToRemove !== null) {
					headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
				} else {
					headers.splice(columnIndexToRemove, 1);
				}
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Sheet 1');
		
			const headerRow = worksheet.addRow(headers);
			headerRow.font = { bold: true };
		
			rows.forEach((row, rowIndex) => {
			    const newRow = worksheet.addRow(Object.values(row));
			    logger("newRow", newRow);
			
			    worksheet.columns.forEach((col, colIndex) => {
			        const headerLength = col.header ? col.header.length : 0; 
			        var maxColumnWidth = col.values.reduce((maxWidth, value) => {
			            if (value && value.length > maxWidth) {
			                return value.length;
			            }
			            return maxWidth;
			        }, 0);
			
			        if (maxColumnWidth > 40) {
			            maxColumnWidth = 40;
			        }
					col.width = Math.max(headerLength, maxColumnWidth) + 2;
					col.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
					if (dataSet[rowIndex]) {
						if (colIndex === 7 && (dataSet[rowIndex].VerifyStatus === 0 || dataSet[rowIndex].VerifyStatus === -1) ){ //
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
						if ((colIndex === 8) && dataSet[rowIndex].overTimeWarning) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
				});
			});
		
			const currentDate = moment.utc().format("yyyy-MM-DD");
			// Generate the Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
					: (filename || 'datatable.xlsx');
				a.click();
			});
			
			
			return false;
		}

    };
    
	var options = {};
	if (!fullScreen) {
		options = {
			...baseOptions,
			tableBodyHeight: "450px",
			tableBodyMaxHeight: "1000px",
			responsive: 'standard',
		}
	} else {
		options = {
			...baseOptions,		
			responsive: 'standard',			
			tableBodyHeight: "800px",  
			tableBodyMaxHeight: "84vh",
			rowsPerPage: initialRowsPerPage,
			selectableRows: 'none',
		}
	}

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };
    
    const calculateRate = (OT, rate, flagType) => {
		if (OT.length) {
			if (flagType === 'OT') {
				return (rate * OT[0].OverTimeWeek).toFixed(2);
			} else if (flagType === 'WND') {
				return (rate * OT[0].OverTimeWeekEnd).toFixed(2);
			} else if (flagType === 'HOL') {
				return (rate * OT[0].OverTimeHoliday).toFixed(2);
			} else {
				return rate;
			}
		}
	};

    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                    Report Unbilled Time Entry
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            //onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Report Unbilled Time Entry
                                        </Typography>
										<FormControl>
											<RadioGroup
											aria-labelledby="radio-buttons-group-label"
											name="radio-buttons-group"
											value={expand}
											onChange={handleRadioButton}
											row
											>
												<Tooltip title="Shows Time Entry Task Variables">
												<FormControlLabel value="summary" control={<Radio sx={{
													'& .MuiSvgIcon-root': {
														color: "white"
													},
												}} />} label="Summary" />
													</Tooltip>
													<Tooltip title="Shows Time Entry detailed Task Variables">
												<FormControlLabel value="detailed" control={<Radio sx={{
													'& .MuiSvgIcon-root': {
														color: "white"
													},
												}} />} label="Detailed" />
													</Tooltip>
											</RadioGroup>
										</FormControl>
										<Button color="inherit" onClick={downloadFile}>
											Download
										</Button>
										<Button color="inherit" onClick={handleGenerate}>
											Generate
										</Button>
                                    </Toolbar>
                                </AppBar>
                                    <DialogTitle>Report Unbilled Time Entry:</DialogTitle>            
                                 <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleStartDate}
                                                value={StartDate}
                                                label="Start Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='end'
                                                id="outlined-EndDate"
                                                type="date"
                                                onChange={handleEndDate}
                                                value={EndDate}
                                                label="End Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                </div>
                            </Form>
                        )}
                        </Formik>                      
						<Dialog
							open={openLogs}
							onClose={handleCloseForLogs}
							fullScreen={fullScreen}
							fullWidth
							maxWidth={fullScreen ? false : 'xl'}
							scroll="paper"
							PaperProps={{
								style: {
									height: fullScreen ? '100vh' : '70vh',
									margin: fullScreen ? 0 : '5vh auto',
									borderRadius: fullScreen ? 0 : 10,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}
							}}
						>
						<DialogContent
								sx={{
									p: 0,
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
									overflow: 'hidden',
								}}
							>
								<Box
									sx={{
										flex: 1,
										overflowY: 'auto',
										overflowX: 'hidden',
										position: 'relative', 
									}}
								>
									<ThemeProvider theme={getMuiTheme()}>
										<MUIDataTable
											title={
												<Box
													sx={{
														display: 'flex',
														alignItems: 'center',
														bgcolor: '#1976d2',
														color: 'white',
														px: 2,
														py: 1,
													}}
												>
													<IconButton color="inherit" onClick={handleCloseForLogs}>
														<CloseIcon />
													</IconButton>
													 <Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
														<IconButton
															color="inherit"
															onClick={fullScreen ? handleMinimize : handleMaximize}
														>
															{fullScreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}
														</IconButton>
													</Tooltip>
													<Typography variant="h6" sx={{ flexGrow: 1, ml: 1 }}>
														Report Unbilled Time Entry
													</Typography>
												</Box>
											}
											data={isLoading ? [] : dataSet}
											columns={customColumns}
											options={isLoading ? muiLoaderOptions(options, isLoading) : options}
										/>
									</ThemeProvider>
							</Box>
						</DialogContent>
					</Dialog>
						<Dialog
			                open={LockedAlert}
			                onClose={handleAlertClose}
			                aria-labelledby="L&P Lock"
			                aria-describedby="Time Period work"
			            >
			                <DialogTitle id="Time Entry">
			                    {"Alert"}
			                </DialogTitle>
			                <DialogContent>
			                    <DialogContentText id="alert-dialog-description">
			                        {AlertText}
			                    </DialogContentText>
			                </DialogContent>
			                <DialogActions>
			                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
			                </DialogActions>
			            </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 